export const initialState = {
  currentLevel: -1, // this should be -2
  isInputChecked: false,
  isModalShown: false,
  quizType: "long", // this should be null
  companyQuestions: null,
  areCompanyQuestionsShown: null,
  isFormComplete: false,
  level: 0,
  quizFinished: false,
  userData: { email: "", fullname: "" },
  language: "en",
  isLangModalShown: true,
  isCookieModalShown: false,
  cookies: { levelTracking: null, ipTracking: null },
};
